<template>
  <!--质量经理上传自检资料-->
  <h-form-page-new :title="title()" @inspection-update="inspectionUpdate">
    <div class="page">
      <div class="table-top">
        <div class="title-table">
          <!-- 基本信息 -->
          <div class="left" style="font-weight: bold;">{{ h_i18n('9e5ffa068ed435ced73dc9bf5dd8e09c') }}</div>
          <!-- 样检单号： -->
          <div class="right h-global-font--blue" @click="lookPlan" style="font-size: 14px">{{ h_i18n('0dfedd58f37571cc86caec5f09366bdb') }}{{ tableData.patternPlanId }}</div>
        </div>
        <!-- <div class="item">
          <table cellspacing="0" cellpadding="0" border="0" class="item_table">
            <colgroup>
              <col width="8%"/>
              <col/>
              <col width="120"/>
              <col width="15%"/>
              <col width="100"/>
              <col width="100"/>
              <col width="120"/>
              <col width="100"/>
              <col width="170"/>
            </colgroup>
            <thead>
            <tr>
              <th>模块商编码</th>
              <th>模块商名称</th>
              <th>专用号</th>
              <th>物料描述</th>
              <th>自检类别</th>             
              <th>产业线</th>
              <th>工厂小微</th>
              <th>检验方式</th>
              <th>自检应完成时间</th>
              <th>文件状态</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ tableData.supplyCode }}</td>
              <td>{{ tableData.supplyName }}</td>
              <td>{{ tableData.mtlNo }}</td>
              <td>{{ tableData.mtlName }}</td>
              <td>{{ tableData.materialLevel }}</td>
              <td>{{ tableData.plName }}</td>
              <td>{{ tableData.sybName }}</td>            
              <td>
                <span v-if="tableData.checkTypeId == 1104" class="warningColor">标准检</span>
                <span v-else-if="tableData.checkTypeId == 1105" class="successColor">免检</span>
                <span v-else-if="tableData.checkTypeId == 1106" class="blueColor">加速检</span>
                <span v-else-if="tableData.checkTypeId == 1141" class="dangerColor">停检</span>
              </td>
              <td>{{ time(tableData.supplierSelfCheckPlanDate, 3) }}</td>
              <td>
                <div v-if="tableData.selfCheckState===2226">自检待上传</div>
                <div class="warningColor" v-if="tableData.selfCheckState===2227">自检待审核</div>
                <div class="warningColor" v-if="tableData.selfCheckState===2229">自检待校核</div>
                <div class="dangerColor" v-if="tableData.selfCheckState===2228">自检审核驳回</div>
                <div class="dangerColor" v-if="tableData.selfCheckState===2236">自检不合格</div>
                <div class="successColor" v-if="tableData.selfCheckState===2230">自检合格</div>
                <div class="successColor" v-if="tableData.selfCheckState===2248">自检待批准</div>
                <div class="successColor" v-if="tableData.selfCheckState===2249">自检批准驳回</div>
                <div v-else></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div> -->
        <div class="detail-content" style="margin-top: 6px;">
          <div class="detail-item">
            <!-- 模块商编码： -->
            <div class="item-label">{{ h_i18n('7f8d2de5a7210365dbc66eabdbfc0315') }}</div>
            <div class="item-content">{{ tableData.supplyCode }}</div>
          </div>
          <div class="detail-item">
            <!-- 模块商名称： -->
            <div class="item-label">{{ h_i18n('7d652e44d79974973925e54ae93c8393') }}</div>
            <div class="item-content">{{ tableData.supplyName}}</div>
          </div>
          <div class="detail-item">
            <!-- 专用号： -->
            <div class="item-label">{{ h_i18n('7c7fefb36371a5a9ab5338c98790c67c') }}</div>
            <div class="item-content">{{tableData.mtlNo }}</div>
          </div>
          <div class="detail-item">
            <!-- 物料描述： -->
            <div class="item-label">{{ h_i18n('ae0a6cd4dc95ffac4ef5ec67199d363a') }}</div>
            <div class="item-content">{{ tableData.mtlName }}</div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;">
          <div class="detail-item">
            <!-- 自检类别： -->
            <div class="item-label">{{ h_i18n('e9578dda62b775c828a9cc05e05bbf61') }}</div>
            <div class="item-content">{{ tableData.materialLevel }}</div>
          </div>
          <div class="detail-item">
            <!-- 产业线： -->
            <div class="item-label">{{ h_i18n('cfff4b0c9ca7597fcf9d6e88d6aaece1') }}</div>
            <div class="item-content">{{ tableData.plName }}</div>
          </div>
          <div class="detail-item">
            <!-- 工厂小微： -->
            <div class="item-label">{{ h_i18n('2153e04c74140dd4926dd724aad0d2a7') }}</div>
            <div class="item-content">{{ tableData.sybName }}</div>
          </div>
          <div class="detail-item">
            <!-- 检验方式： -->
            <div class="item-label">{{ h_i18n('62d773f2fea6b5cc3313bfa1d0af5df4') }}</div>
            <div class="item-content">
              <!-- 标准检 -->
              <span v-if="tableData.checkTypeId == 1104" class="warningColor">{{ h_i18n('dc6f3f35fdea3ae845d417b4c4127e20') }}</span>
              <!-- 免检 -->
              <span v-else-if="tableData.checkTypeId == 1105" class="successColor">{{ h_i18n('ca3179550e48755ebbf44397f7af708b') }}</span>
              <!-- 加速检 -->
              <span v-else-if="tableData.checkTypeId == 1106" class="blueColor">{{ h_i18n('0ab16539ed7be5709b361d350956ab43') }}</span>
              <!-- 停检 -->
              <span v-else-if="tableData.checkTypeId == 1141" class="dangerColor">{{ h_i18n('8177e5fe9e704bb4da0da6afe0da0da9') }}</span>
            </div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;">
          <div class="detail-item">
            <!-- 自检应完成时间： -->
            <div class="item-label1">{{ h_i18n('acea584c9d462f33c473cd327b1fafdd') }}</div>
            <div class="item-content"><span>{{ time(tableData.supplierSelfCheckPlanDate, 3) }}</span></div>
          </div>
          <div class="detail-item">
            <!-- 文件状态： -->
            <div class="item-label">{{ h_i18n('1be8b03ef2808b91ee3198b2fd219167') }}</div>
            <div class="item-content">
              <!-- 自检待上传 -->
              <div v-if="tableData.selfCheckState===2226">{{ h_i18n('362b0ac9a97560271534c66a3abd336b') }}</div>
              <!-- 自检待审核 -->
              <div class="warningColor" v-if="tableData.selfCheckState===2227">{{ h_i18n('31f3cda12f66898443a5cbae5a59a54f') }}</div>
              <!-- 自检待校核 -->
              <div class="warningColor" v-if="tableData.selfCheckState===2229">{{ h_i18n('ad99be837949c976c9442b08d5fe0983') }}</div>
              <!-- 自检审核驳回 -->
              <div class="dangerColor" v-if="tableData.selfCheckState===2228">{{ h_i18n('b1d80f4be451870aad10bd88b42f4c27') }}</div>
              <!-- 自检不合格 -->
              <div class="dangerColor" v-if="tableData.selfCheckState===2236">{{ h_i18n('fe9cbe5433b77ade8db68484af57bdeb') }}</div>
              <!-- 自检合格 -->
              <div class="successColor" v-if="tableData.selfCheckState===2230">{{ h_i18n('3aa9d9ef4b6973e14519ec1a37189e27') }}</div>
              <!-- 自检待批准 -->
              <div class="successColor" v-if="tableData.selfCheckState===2248">{{ h_i18n('b1b793381d349ecd6b67cfacc2b0ab40') }}</div>
              <!-- 自检批准驳回 -->
              <div class="successColor" v-if="tableData.selfCheckState===2249">{{ h_i18n('2cf37ff600fbfd0f0728b6202b1f328c') }}</div>
              <div v-else></div>
            </div>
          </div>
          <div class="detail-item" v-if="selfDelayReasonShow">
            <!-- 自检拖期原因 -->
            <div class="item-label" style="width: 100px;">{{ h_i18n('001768F5D0D251C2E86828DBCE241DA7') }}：</div>
            <div class="item-content" style="transform: translate(5px, -5px);">
              <!-- 自检批准 formType==='upload-b 只查看 -->
              <el-select v-model="selfDelayReason" placeholder="请选择" style="width: 100%;"
                @change="selfDelayReasonChoose()" filterable :disabled="formType==='upload-b'">
                <el-option v-for="item in selfDelayReasonData" :value="item.value" :key="item.value" :label="item.label"></el-option>
              </el-select>
            </div>
          </div>
          
        </div>
        <div class="detail-content" style="margin-top: 12px;" v-if="selfDelayReasonRemarkShow">
          <div class="detail-item" style="width:100%;">
            <!-- 自检拖期其它原因说明 -->
            <div class="item-label" style="width: 100px;padding-right:16px;">{{ h_i18n('D4FF3F11C2E31A4448B6D158CDEB3690') }}：</div>
            <div class="item-content" style="transform: translateY(5px, -5px);width: 90%;">
              <el-input class="default_input_style" v-model="selfDelayReasonRemark" show-word-limit maxlength="200" :rows="3" type="textarea" placeholder="请输入" :disabled="formType==='upload-b'"></el-input>
            </div>
          </div>
        </div>
        <div class="detail-content" style="margin-top: 12px;">
          <div class="detail-item">
            <!-- 产地： -->
            <div class="item-label" style="width:45px">{{ h_i18n('0985401cbacaabafcfe3365628af9393') }}</div>
            <div class="item-content">
              <el-select v-model="placeOriginText" :disabled="formType==='upload-b'">
                <el-option v-for="item in placeOriginList" :key="item.supplyCode" :label="item.supplyCode+'-'+item.factoryAdress+'-'+item.factoryArea" :value="item.addressNo || item.factoryAdress"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-tab">
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
          <!-- 二三级物料 -->
          <el-tab-pane :label="h_i18n('749ad86b2e655706785f3e38b9e7031c')" name="1">
            <div class="tab-item">
              <div class="table-item-button">
                <template v-if="formType==='upload'">
                  <h-button type="primary" @click="upload=true">
                    <template #icon>
                      <afferent-three/>
                    <!-- 导入 -->
                    </template>{{ h_i18n('8d9a071ee2ef45e045968e117a205c07') }}</h-button>
                  <h-button type="danger" style="margin-left: 12px" :disabled="multipleSelection.length===0" @click="deleteItemAll">
                    <template #icon>
                      <delete/>
                    <!-- 删除 -->
                    </template>{{ h_i18n('2f4aaddde33c9b93c36fd2503f3d122b') }}</h-button>
                </template>
                <!-- 注意：二三级物料包含供应商自制物料和外协采购物料（必填项）、说明：I级：供应商自制；II级：供应商采购；III级：供应商的供应商采购 -->
                <div class="text">{{ h_i18n('ebd4ade3e13cb533ba22e82e8172e47b') }}</div>
              </div>
              <div class="table-item-table">
                <!-- 新品检验计划 -->
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')" :is-left="formType==='upload'?2:1" :h-data="tableList.sTMaterialsList" :is-right="formType==='upload'?1:0">
                  <!-- 请点击“查询”数据 -->
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.sTMaterialsList" style="border-radius: 8px"
                            @row-click.self="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            @selection-change="listCheckBoxChange" ref="sTMaterialsList" :class="formType==='upload'?'row-change':''">
                    <el-table-column type="selection" width="40" v-if="formType==='upload'"></el-table-column>
                    <!-- 序号 -->
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <!-- 物料等级 -->
                    <el-table-column :label="h_i18n('d95cf47ff6633b3bea0c6b2c82f50107')" width="200">
                      <template #default="{row}">
                        <!-- I级；II级；III级 -->
                        <div v-if="!row.checkFront" class="text_item">{{ row.series === "1" ? h_i18n('a86b76d1ac7e23fbe6811914dddedd66') : row.series === "2" ? h_i18n('50657dd5fba0f4c56301994b9435ed73') : row.series === "3" ? h_i18n('6d29d5c1c563430c254a0571e5498a5f') : "" }}</div>
                        <el-select v-else v-model="row.series">
                          <!-- I级 -->
                          <el-option value="1" :label="h_i18n('a86b76d1ac7e23fbe6811914dddedd66')"></el-option>
                          <!-- II级 -->
                          <el-option value="2" :label="h_i18n('50657dd5fba0f4c56301994b9435ed73')"></el-option>
                          <!-- III级 -->
                          <el-option value="3" :label="h_i18n('6d29d5c1c563430c254a0571e5498a5f')"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <!-- 零件号码 -->
                    <el-table-column :label="h_i18n('82428b489879f605914215b9876caa40')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.partNumber }}</div>
                        <el-input v-else v-model="row.partNumber"></el-input>
                      </template>
                    </el-table-column>
                    <!-- 零件名称 -->
                    <el-table-column :label="h_i18n('2bb79b0b11fb5f902349598676e2060e')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.partName }}</div>
                        <el-input v-else v-model="row.partName"></el-input>
                      </template>
                    </el-table-column>
                    <!-- 材料名称 -->
                    <el-table-column :label="h_i18n('9ee1d06b4fb650c3e5fcc49929675caf')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.materialName }}</div>
                        <el-input v-else v-model="row.materialName"></el-input>
                      </template>
                    </el-table-column>
                    <!-- 规格参数 -->
                    <el-table-column :label="h_i18n('40c9875bd7978fac4de81ef58a454d28')" min-width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.specification }}</div>
                        <el-input v-else v-model="row.specification"></el-input>
                      </template>
                    </el-table-column>
                    <!-- 自制/外协零件 -->
                    <el-table-column :label="h_i18n('ed765ced3449b75aa70a4f5c10ad1334')" prop="Zip" width="270">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.partStatusList.join(",") }}</div>
                        <el-checkbox-group class="center" v-model="row.partStatusList" v-else @change="specificationChange(row)" size="small">
                          <!-- 自制 -->
                          <el-checkbox :label="h_i18n('f5f45a306153e09e6b55aa8989e62e29')"/>
                          <!-- 外协 -->
                          <el-checkbox :label="h_i18n('762f7d6568ff7dcbccb00c818e08c451')"/>
                        </el-checkbox-group>
                      </template>
                    </el-table-column>
                    <!-- 产品/材料供应商 -->
                    <el-table-column :label="h_i18n('4dfbb9aa4ac63454b70dfd8bbe09def7')" prop="Zip" width="160">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.productSupplier }}</div>
                        <el-input v-else v-model="row.productSupplier"></el-input>
                      </template>
                    </el-table-column>
                    <!-- 操作 -->
                    <el-table-column :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" width="120" v-if="formType==='upload'">
                      <template #default="{row}">
                        <!-- 删除 -->
                        <div class="h-global-font--blue text_item_delete" style="color:#F53F3F" @click.stop="deleteItem(row.checkFrontId)">{{ h_i18n('2f4aaddde33c9b93c36fd2503f3d122b') }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
                <h-button v-if="formType==='upload'" type="primary" style="margin-top: 10px" @click="addItem()">
                  <!-- 添加一项 -->
                  <add-one/>{{ h_i18n('85f3189774581e5dcd697cfced4251d3') }}</h-button>
              </div>
            </div>
          </el-tab-pane>
          <!-- 检验测试 -->
          <el-tab-pane :label="h_i18n('23e0cee4c780d1d70657b0b32005fed2')" name="2">
            <div class="tab-item">
              <div class="table-item-button">
                <!-- 注意：检验测试模块只能保存填写完整的行信息。 -->
                <div class="text">{{ h_i18n('2e64fa07cef87c82c0adacb0dc31a75f') }}</div>
              </div>
              <div class="table-item-table">
                <!-- 新品检验计划 -->
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <!-- 请点击“查询”数据 -->
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.inspectionTesting" style="border-radius: 8px"
                            @row-click="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            ref="inspectionTesting" :class="formType==='upload'?'row-change':''">
                    <!-- 序号 -->
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isMust==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <!-- 项目 -->
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" prop="project" min-width="230">
                      <template #default="{row}">
                        <div class="text_item">{{ row.project }}</div>
                      </template>
                    </el-table-column>
                    <!-- 是否合格 -->
                    <el-table-column :label="h_i18n('3ba97bd751e79dff382d6ca65e4e3553')" prop="State" width="100">
                      <template #default="{row}">
                        <!-- 是；否；请选择 -->
                        <div v-if="!row.checkFront" class="text_item">{{ row.qualifiedStatus === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.qualifiedStatus === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : row.qualifiedStatus === "/" ? "/" : h_i18n('708c9d6d2ad108ab2c560530810deae9') }}</div>
                        <el-select v-else v-model="row.qualifiedStatus">
                          <!-- 是 -->
                          <el-option key="1" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')" value="Y"></el-option>
                          <!-- 否 -->
                          <el-option key="2" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')" value="N"></el-option>
                          <el-option key="3" label="/" value="/"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <!-- 检测时间 -->
                    <el-table-column :label="h_i18n('44c4227175922c94497714edab9db531')" prop="City" width="230">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ time(row.testTime) }}</div>
                        <el-date-picker v-else v-model="row.testTime" @change="timeFormatter(row,'testTime')" type="date"></el-date-picker>
                      </template>
                    </el-table-column>
                    <!-- 附件 -->
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" prop="Address" width="200">
                      <template #default="{row}">
                        <template v-if="row.project==='出厂检验报告模板'">
                          <!-- 查看 -->
                          <div v-if="formType === 'upload-b'" class="h-global-font--blue text_item_delete" @click="redact(row,h_i18n('607e7a4f377fa66b0b28ce318aab841f'))">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
                          <!-- 编辑 -->
                          <div v-else class="h-global-font--blue text_item_delete" @click="redact(row,h_i18n('95b351c86267f3aedf89520959bce689'))">{{ h_i18n('95b351c86267f3aedf89520959bce689') }}</div>
                        </template>
                        <template v-else>
                          <!-- 上传附件 -->
                          <div v-if="!row.fileName" class="h-global-font--blue text_item_delete" @click="fileUploadToOSS(row)">{{ h_i18n('0063c51e228e58fddadbff82a79cf3c0') }}</div>
                          <h-file v-else :name="row.fileName" :delete-type="formType==='upload'" :url="row.fileUuid" @delete="deleteFile(row)"></h-file>
                        </template>
                      </template>
                    </el-table-column>
                    <!-- 报告出具人 -->
                    <el-table-column :label="h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')" prop="Zip" width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.submitMan }}</div>
                        <el-input v-else v-model="row.submitMan" maxlength="50"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>
          <!-- 技术标准 -->
          <el-tab-pane :label="h_i18n('542c3a3ec2d96f011386760d7382940f')" name="3">
            <div class="tab-item">
              <div class="table-item-button">
                <!-- 注意：技术标准模块只能保存填写完整的行信息。 -->
                <div class="text">{{ h_i18n('ce5be64e3ed4f800b03b83d527bfadfc') }}</div>
              </div>
              <div class="table-item-table">
                <!-- 新品检验计划 -->
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <!-- 请点击“查询”数据 -->
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.technicalStandard" style="border-radius: 8px"
                            @row-click="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            ref="technicalStandard" :class="formType==='upload'?'row-change':''">
                    <!-- 序号 -->
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isMust==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <!-- 项目 -->
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="230">
                      <template #default="{row}">
                        <div class="text_item">{{ row.project }}</div>
                      </template>
                    </el-table-column>
                    <!-- 是否合格 -->
                    <el-table-column :label="h_i18n('3ba97bd751e79dff382d6ca65e4e3553')" width="100">
                      <template #default="{row}">
                        <!-- 是；否；请选择 -->
                        <div v-if="!row.checkFront" class="text_item">{{ row.qualifiedStatus === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.qualifiedStatus === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : row.qualifiedStatus === "/" ? "/" : h_i18n('708c9d6d2ad108ab2c560530810deae9') }}</div>
                        <el-select v-else v-model="row.qualifiedStatus">
                          <!-- 是 -->
                          <el-option key="1" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')" value="Y"></el-option>
                          <!-- 否 -->
                          <el-option key="2" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')" value="N"></el-option>
                          <el-option key="3" label="/" value="/"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <!-- 附件 -->
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" width="200">
                      <template #default="{row}">
                        <!-- 上传附件 -->
                        <div v-if="!row.fileName" class="h-global-font--blue text_item_delete" @click="fileUploadToOSS(row)">{{ h_i18n('0063c51e228e58fddadbff82a79cf3c0') }}</div>
                        <h-file v-else :name="row.fileName" :delete-type="formType==='upload'" :url="row.fileUuid" @delete="deleteFile(row)"></h-file>
                      </template>
                    </el-table-column>
                    <!-- 报告出具人 -->
                    <el-table-column :label="h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')" width="200">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.submitMan }}</div>
                        <el-input v-else v-model="row.submitMan" maxlength="50"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>
          <!-- 有害物质 -->
          <el-tab-pane :label="h_i18n('f7ef9633c64559e80c654567ca5ddd96')" name="4">
            <div class="tab-item">
              <div class="table-item-button">
                <!-- 注意：1、请填写外检审核通过的宣告表编号（首页-有害物质-RoHS-宣告表）2、如涉及到REACH或毒性报告等，需上传附件。 -->
                <div class="text">{{ h_i18n('f893acad539b7573e24937852be3ecd6') }}</div>
              </div>
              <div class="table-item-table">
                <!-- 新品检验计划 -->
                <h-table-card :title="h_i18n('19fde6e4eac33cf5a9befed79c2309c8')">
                  <!-- 请点击“查询”数据 -->
                  <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" border :data="tableList.hazardousSubstances" style="border-radius: 8px"
                            @row-click="rowClick" :highlight-current-row="true" v-loading="tableListLoading"
                            ref="hazardousSubstances" :class="formType==='upload'?'row-change':''">
                    <!-- 序号 -->
                    <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')"></el-table-column>
                    <el-table-column label="*" width="60">
                      <template #header>
                        <div class="dangerColor center">*</div>
                      </template>
                      <template #default="{row}">
                        <div class="dangerColor center" v-if="row.isMust==='Y'">*</div>
                      </template>
                    </el-table-column>
                    <!-- 项目 -->
                    <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" min-width="230">
                      <template #default="{row}">
                        <div class="text_item">{{ row.project }}</div>
                      </template>
                    </el-table-column>
                    <!-- 宣告表编号 -->
                    <el-table-column :label="h_i18n('c2cf8689fd0e8203797dbbd7f8475ff0')" width="270">
                      <template #default="{row}">
                        <div v-if="!row.checkFront" class="text_item">{{ row.rohsNo }}</div>
                        <el-select v-else v-model="row.rohsNo" filterable @change="rohNoM(row)">
                          <el-option v-for="item in declarationFormList" :key="item" :label="item.rohsNo" :value="item.rohsNo"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <!-- 宣告表详情 -->
                    <el-table-column :label="h_i18n('97e203313843643e68a5225ae227359e')" width="220">
                      <template #default="{row}">
                        <!-- 查看 -->
                        <div class="h-global-font--blue text_item_delete" @click="goDetail(row)">{{ h_i18n('607e7a4f377fa66b0b28ce318aab841f') }}</div>
                      </template>
                    </el-table-column>
                    <!-- 附件 -->
                    <el-table-column :label="h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')" width="200">
                      <template #default="{row}">
                        <!-- 上传附件 -->
                        <div v-if="!row.fileName" class="h-global-font--blue text_item_delete" @click="fileUploadToOSS(row)">{{ h_i18n('0063c51e228e58fddadbff82a79cf3c0') }}</div>
                        <h-file v-else :name="row.fileName" :url="row.fileUuid" :delete-type="formType==='upload'" @delete="deleteFile(row)"></h-file>
                      </template>
                    </el-table-column>
                    <!-- 是否合格 -->
                    <el-table-column :label="h_i18n('3ba97bd751e79dff382d6ca65e4e3553')" width="100">
                      <template #default="{row}">
                        <!-- 是；否；请选择 -->
                        <div v-if="!row.checkFront" class="text_item">{{ row.judge === "Y" ? h_i18n('0a60ac8f02ccd2cf723f927284877851') : row.judge === "N" ? h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') : row.judge === "/" ? "/" : h_i18n('708c9d6d2ad108ab2c560530810deae9') }}</div>
                        <el-select v-else v-model="row.judge">
                          <!-- 是 -->
                          <el-option key="1" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')" value="Y"></el-option>
                          <!-- 否 -->
                          <el-option key="2" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')" value="N"></el-option>
                          <el-option key="3" label="/" value="/"></el-option>
                        </el-select>
                      </template>
                    </el-table-column>
                    <!-- 报告出具人 -->
                    <el-table-column :label="h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')" width="200">
                      <template #default="{row}">
                        <!-- <div class="text_item">{{ row.submitMan }}</div> -->
                        <div v-if="!row.checkFront" class="text_item">{{ row.submitMan }}</div>
                        <el-input v-else v-model="row.submitMan" maxlength="50"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </h-table-card>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="footer_check" v-if="formType==='upload'">
          <!-- 我司承诺提交资料真实有效，否则愿承担相应责任。 -->
          <el-checkbox v-model="commitment">{{ h_i18n('833e219602121ac56bace95cf6806311') }}</el-checkbox>
        </div>
      </div>
      <div class="table-footer">
        <h-button-group align="center">
          <!-- 正常提交 -->
          <!-- 暂存 -->
          <h-button type="primary" @click="saveAll" v-if="formType==='upload'">{{ h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa') }}</h-button>
          <!-- 提交 -->
          <h-button type="primary" @click="submitAll" v-if="formType==='upload'">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
          <!-- 提交后的校核 -->
          <!-- 批准 -->
          <h-button type="primary" @click="approvePlan" v-if="formType==='upload-b'">{{ h_i18n('7a712b9a4574166830b69a07ce78056e') }}</h-button>
          <!-- 返回 -->
          <h-button type="primary" @click="goBack" v-if="formType==='upload-b'">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
          <!-- 返回 -->
          <h-button type="primary" @click="goBack2" v-if="formType==='upload'">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>
    </div>
    <!--上传-->
    <!-- 文件上传 -->
    <h-dialog :show="fileUpload" class="dialog_padding_style" :title="h_i18n('481e034e6026969aae4ce7ce7c8a7b6f')" footer @close="fileUpload=false" width="700px">
      <h-upload @file-change="chooseFile" :max="200" :max-length="1" @error="uploadError" :file-list="fileList" h-accept='pdf,xls,xlsx,ppt,doc,docx,pptx,txt,png,jpg,jpeg,rar,zip,PDF,XLS,XLSX,PPT,DOC,DOCX,PPTX,TXT,PNG,JPG,JPEG,RAR,ZIP'>
        <template #tips>
          <div>{{ h_i18n('6ea134b93bc09696acf1b5a29777d3ad') }}</div>
        </template>
      </h-upload>
      <template #footer>
        <h-button-group align="right">
          <h-button type="primary" @click="uploadFile">{{ h_i18n('e83a256e4f5bb4ff8b3d804b5473217a') }}</h-button>
        </h-button-group>
      </template>
    </h-dialog>
    <!--导入模版-->
    <!-- 模版导入 -->
    <h-upload-template class="import_style" :loading="loadingDown" @error="uploadError" :title="h_i18n('db547c476bed52ec7c8ea817e929b790')" :show="upload" @close="closeUpload" :status="status" :dataList="dataList" @download="download" @fileChange="uploadTemplate"></h-upload-template>
    <!--质量部长校核-->
    <el-drawer v-model="ratify" :show-close="false" size="800px">
      <template #title>
        <!-- 新品报验批准 -->
        <div class="titleDrawer">{{ h_i18n('3365f22fb92ca9e0c7acfe00767d0c23') }}</div>
        <h-button type="primary" @click="approveAll">
          <template #icon>
            <send theme="outline"/>
          <!-- 提交 -->
          </template>{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
        <h-button style="margin-left: 10px" type="warning" @click="ratify=false">
          <template #icon>
            <close theme="outline"/>
          <!-- 关闭 -->
          </template>{{ h_i18n('b15d91274e9fc68608c609999e0413fa') }}</h-button>
      </template>
      <template #default>
        <div>
          <!-- 请点击“查询”数据 -->
          <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="false" height="100%" border :data="approveList">
            <!-- 项目 -->
            <el-table-column :label="h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')" width="180">
              <template #default="{row}">
                {{ row.project }}
              </template>
            </el-table-column>
            <!-- 批准结论 -->
            <el-table-column :label="h_i18n('c8fecf8b1438559e9914fbc473c15ae3')" width="180">
              <template #default="{row}">
                <el-select v-model="row.conclusion">
                  <!-- 通过 -->
                  <el-option value="Y" :label="h_i18n('23c1f39900b3af4c3263449782e288e1')"></el-option>
                  <!-- 不通过 -->
                  <el-option value="N" :label="h_i18n('dec0624c91cfca219e1b41ce89c19780')"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <!-- 备注 -->
            <el-table-column :label="h_i18n('2432b57515b3627faddccb1dd1df206e')" min-width="260">
              <template #default="{row}">
                <el-input v-model="row.reason"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer_check_ratify">
            <el-checkbox v-model="commitmentRatify">
              <!-- 我司承诺提交资料真实有效，否则愿承担相应责任。 -->
              <span style="white-space: wrap;">{{ h_i18n('833e219602121ac56bace95cf6806311') }}</span>
            </el-checkbox>
          </div>
        </div>
      </template>
    </el-drawer>
  </h-form-page-new>


</template>




<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import {Download, Http, Log, MultipleChoiceEnhancement} from "../Decorator";

export default {
  name: "UploadSelfInspectionData",
  data() {
    return {
      activeName: "1",
      beforeData: {},
      tableData: {},
      mainData: {},
      tableList: {
        sTMaterialsList: [],
        inspectionTesting: [],
        technicalStandard: [],
        hazardousSubstances: []
      },
      tableListLoading: false,
      multipleSelection: [],
      fileUpload: false,
      nowItem: {},
      fileList: [],
      cataId: 0,
      loadingDown: false,
      upload: false,
      dataList: [],
      status: "",
      commitment: false,
      declarationFormList: [],
      name: "",

      ratify: false,
      approveList: [],
      commitmentRatify: false,
      formType: "",
      placeOriginList: [],//产地
      placeOriginText: "", //产地选中

      selfDelayReason:'',  // 自检拖期原因
      selfDelayReasonRemark:'', // 自检拖期自定义原因
      selfDelayReasonData:[],  // 自检拖期列表
      selfDelayReasonShow:false,// 自检拖期原因输入 是否显示
      selfDelayReasonRemarkShow:false,// 自检拖期自定义原因输入 是否显示
    }
  },
  mounted() {
    this.name = this.$route.query.name
    this.init()
  },
  methods: {
    h_i18n,
    // 产地改为addressNo后，验证选中的addressNo值是否存在，不存在则尝试用factoryAdress匹配
    validateSelectedValue () {
      // 查找是否有匹配的addressNo
      const hasFactoryAdressMatch = this.placeOriginList.some(item => item.addressNo === this.placeOriginText)
      if (!hasFactoryAdressMatch) {
        // 查找factoryAdress匹配项
        const factoryAdressMatch = this.placeOriginList.find(item => item.factoryAdress === this.placeOriginText)
        if (factoryAdressMatch) {
          // 若factoryAdress存在，更新选中值为实际value（id或key）
          this.placeOriginText = factoryAdressMatch.addressNo ?? factoryAdressMatch.factoryAdress
        } else {
          // 若都不匹配，清空选中值
          this.placeOriginText = ''
        }
      }
    },
    // 查询状态表
    getBaseValues(){
      this.$http({
        method: "post",
        url: "/base/basicData/listBaseValuesByIds",
        data: [112],
      }).then((res) => {
        if (res.data.code === "200") {
          res.data.data.forEach(item=>{
            // 拖期原因走配置表
            if(item.valueTypeId === 112){
              this.selfDelayReasonData.push({value:item.valueId,label:item.valueName})
            }
          })
        } else {
        }
      }).catch((err) => {
      });
    },
    // 判断是否拖期送样 如果是操作送样 根据时间判断
    isSelfDelay(){
      console.log('tableData.supplierSelfCheckPlanDatetableData.supplierSelfCheckPlanDate',this.tableData.supplierSelfCheckPlanDate)
      let nowDate = new Date().getTime()
      // 应送样时间 只取年月日
      let supplierSelfCheckPlanDate = this.time(this.tableData.supplierSelfCheckPlanDate,3)
      // 加上时分秒
      supplierSelfCheckPlanDate += ' 23:59:59'
      // 时间戳
      supplierSelfCheckPlanDate = new Date(supplierSelfCheckPlanDate).getTime()
      
      if(nowDate > supplierSelfCheckPlanDate){
        console.log('拖期了！！！！！！！！！！！！！')
        
        this.selfDelayReasonShow = true
      }
    },
    // 拖期原因选择
    selfDelayReasonChoose(){
      if(!this.selfDelayReason){
        this.selfDelayReasonRemark = undefined
      }else{
        if(this.selfDelayReason === 2140860443){
          this.selfDelayReasonRemarkShow = true
        }else{
          this.selfDelayReasonRemark = undefined
          this.selfDelayReasonRemarkShow = false
        }
      }
    },
    ///basicData/selectSupplyAddressList 产地查询
    placeOrigin() {
      this.$http({
        method: "get",
        url: "/base/basicData/selectSupplyAddressList?supplyCode=" + this.tableData.supplyCode,
      }).then(res => {
        if (res.data.code === "200") {
          this.placeOriginList = res.data.data
          this.validateSelectedValue()
        }
      }).catch(res => {

      })
    },
    goDetail(row) {
      if (row.rohsNo && row.rohsNo != '无') {
        // let url = process.env.NODE_ENV === "test" ? "http://sqm-test.qd-huangdao-test.haier.net/" : process.env.NODE_ENV === "production" ? "http://sqm.haier.net/" : ""
        // window.open(url + "newproduct/rohs_detail_haier_index?id=" + row.rohsNo, "_black");
        let routeData = this.$router.resolve({
          name: "rohsDeclarationFormDetail",
          query: {
            dataFrom:'sqm',
            kindType:'sqmDetail',
            supplyCode:this.tableData.supplyCode,
            supplyName:this.tableData.supplyName,
            rohsNo:row.rohsNo,
            id: row.rohsId
          }
        })
        // 新窗口打开
        window.open(routeData.href, "_blank");

      } else {
        // 不是有效的宣告表编号, 请输入外检审核通过的宣告表编号。
        this.info(h_i18n('7435bdcd1a5956a38b04f15fef15d086'));
      }
    },
    lookPlan() {
      this.$router.push('/SampleInspectionFormLook?patternPlanId=' + this.tableData.patternPlanId+'&dataFrom=sqm')
    },
    lookM(a, b) {
      this.$router.push({
        name: "EnterpriseStandardList",
        query: {
          mtlNo: a,
          supplyCode: b
        }
      })
    },
    title() {
      if (this.formType === 'upload') {
        // 自检报告上传
        return h_i18n('8f5aa78d7ea46a3696bb861be5d0b55d')
      } else {
        // 新品报验批准
        return h_i18n('3365f22fb92ca9e0c7acfe00767d0c23')
      }
    },
    //****************************************************自检上传****************************************************
    //进入查询
    async init() {
      this.formType = this.$route.query.formType
      this.beforeData = JSON.parse(this.$route.query.data)
      await this.searchTableList()
      await this.selectDeclarationForm(this.tableData.supplyCode, "", this.tableData.mtlNo)
      // 因为质量部长批准也走这个页面，必须查配置表
      this.getBaseValues()
      this.isSelfDelay()
      await this.placeOrigin()
      //如果是批准
      if (this.formType === 'upload-b') {
        let obj = {
          project: "",
          conclusion: "",
          reason: "",
          cataId: this.cataId
        }
        let list = ["二三级物料", "检验测试", "技术标准", "有害物质"]
        for (let i = 0; i < list.length; i++) {
          obj.project = list[i]
          obj.conclusion = "Y"
          this.approveList.push(JSON.parse(JSON.stringify(obj)))
        }
      }
      setTimeout(() => {
        this.postThisPageHeightMore()
      }, 10);
    },
    //检验测试-编辑this.tableData.supplyCode, "", this.tableData.mtlNo
    redact(row,type) {
      let pathName = ''
      if(type === '查看'){
        pathName = 'FactoryTemplateSqmTemplateDetail'
      }else {
        pathName = 'FactoryTemplateSqmTemplateAdd'
      }
      // this.startLoading(h_i18n('f2a88edc8adb598632ba1c6f89279b89'))
      // this.$http({
      //   method: "GET",
      //   url: "/base/patternPlan/getMklInfo?mtlNo=" + this.tableData.mtlNo + "&supplyCode=" + this.tableData.supplyCode,
      // }).then((res) => {
      //   this.closeLoading()
      //   if (res.data.code === "200") {
          // this.$router.push({
          //   name: "ReportTemplate",
          //   query: {
          //     mtlNo: this.tableData.mtlNo,
          //     supplyCode: this.tableData.supplyCode,
          //     name: this.name,
          //     nickName: this.$route.query.nickName,
          //     dataFrom: "sqm",
          //     flag: "edit",
          //     changeStatus: "N",
          //     versionNo: "V1.0",
          //     shipmentId: res.data.shipmentId,
          //     dataFromFlag: "close",
          //     roleCode: this.$route.query.roleCode
          //   }
          // })
          let list = {
              mtlNo: this.tableData.mtlNo,
              mtlName: this.tableData.mtlName,
              supplyCode: this.tableData.supplyCode
            };
            // this.$store.commit('setList', res);
            this.$router.push({
              name: pathName,
              query: {
                    name: this.name,
                    nickName: this.$route.query.nickName,
                    mtlNo:this.tableData.mtlNo,
                    type: '3',
                    newType: 'new', // 新品进入模板的
                    dataFrom: 'sqm',
                    supplyCode:  this.tableData.supplyCode,
                    data: JSON.stringify(list),
                  }
          });
      //   } else {
      //     this.closeLoading()
      //     this.error(h_i18n('57738c8a6a20c40f544b2f5c17447298'))
      //   }
      // })
    },
    rohNoM(row) {
      let l = this.declarationFormList.filter(v => v.rohsNo === row.rohsNo)
      row.judge = l[0]["effectStatus"] === "1" ? "Y" : "N"
      row.rohsId = l[0].id
    },
    //时间格式化
    timeFormatter(row, type) {
      row[type] = this.time(row[type], 3)
    },
    //二三级物料，下载模版
    // 二三级物料导入模版.xlsx
    @Download("/base/fileDownload/downloadFile?filePath=mkhl/bukl/202307/a2478c44d2f94263800b62791a526618.xlsx", "GET", h_i18n('abee8ba959290abc34b8cb12bd4f46d5'))
    download(callback) {
      callback().then(v => {
        // 下载成功
        this.success(h_i18n('50940ed76fb720f73efb6f5fa91d3ee3'))
      }, v => {
        // 下载失败
        this.error(h_i18n('65e200d30c86a93c46dcafaa151028f5'))
      })
    },
    //关闭导入模版
    closeUpload() {
      this.upload = false
      this.dataList = []
      this.status = ""
    },
    //二三级物料，自制外协切换
    specificationChange(row) {
      // 自制；外协
      row.partStatus = row.partStatusList.join(",").replace(h_i18n('f5f45a306153e09e6b55aa8989e62e29'), "1").replace(h_i18n('762f7d6568ff7dcbccb00c818e08c451'), "2")
    },
    //删除上传后的文件
    deleteFile(row) {
      row.fileName = ""
      row.fileUuid = ""
    },
    //二三级物料，模版导入
    uploadTemplate(file) {
      const formData = new FormData()

      formData.append("myFile", file)
      this.dataList = []
      this.status = ""
      // 解析中...
      this.startLoading(h_i18n('0b7da7ede9fae2ca88bfc8c9baabdfd1'))
      this.$http({
        method: "post",
        url: "/base/patternPlan/importMaterial?userName=" + this.$route.query.nickName + "&cataId=" + this.cataId,
        data: formData,
      }).then((res) => {
        if (res.data.code === "200") {
          this.status = "success"
          // 导入成功
          this.dataList = [h_i18n('b6d16a8173dd0d43f580bc6882dc5e9a')]
          this.closeLoading()
          this.closeUpload()
          // this.paginationQuery(this.pageNation.pageIndex)
          this.searchTableList()
        } else {
          this.status = "error"
          this.dataList = res.data.data
          this.closeLoading()
        }
      })
    },
    //上传文件
    uploadFile() {
      let uploadList = this.fileList.filter(v => v.status !== "success")
      if (uploadList.length === 0) {
        this.warning(h_i18n('d7be58c93368dc1797cd10e4a845ce30'))
        return
      }
      let formData = new FormData()
      uploadList.map(v => {
        formData.append('files', v.file)
        v.progress = 50
      })
      return this.$http({
        method: 'post',
        url: '/base/fileUpload/uploadToOssSaveUrl',
        headers: {'Content-Type': 'multipart/form-data'},
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then((res) => {
        if (res.data.code === "0") {
          this.nowItem.fileUuid = res.data.data
          this.nowItem.fileName = uploadList[0].name
          console.log(uploadList[0].name)
          uploadList.map(v => {
            v.progress = 100
            v.status = "success"
          })
          this.success({
            // 提示
            title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
            // 上传成功
            message: h_i18n('a7699ba73144aad544eb9ac49f82749d'),
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: async action => {
              this.fileUpload = false
              this.fileList = []
            }
          })
        } else {
          return Promise.reject()
        }
      }).catch((err) => {
        uploadList.map(v => {
          v.progress = 100
          v.status = "fail"
        })
        this.error(h_i18n('54e5de428ca9d59119d4624706215a4d'))
      });
    },
    //选择文件
    chooseFile(fileList,fileList2) {
      this.fileList = [fileList]
      fileList2.length ? '' : this.fileList = []
    },
    //文件上传，报错信息和提示
    uploadError(text) {
      console.log(text);
      
      this.warning(text)
    },
    //上传附件，并且保存当前行信息
    fileUploadToOSS(row) {
      this.nowItem = row
      this.fileUpload = true
    },
    //二三级物料，列表选中
    listCheckBoxChange(val) {
      this.multipleSelection = val.map(v => v.checkFrontId);
    },
    //二三级物料，添加行
    @MultipleChoiceEnhancement()
    addItem() {
      let tempRow = {
        cataId: this.cataId,
        series: "",
        partNumber: "",
        partName: "",
        materialName: "",
        specification: "",
        partStatusList: [],
        partStatus: "",
        checkFront: false,
        checkFrontId: this.md5(this.uuid2()),
        checkFrontType: "sTMaterialsList"
      }
      this.tableList.sTMaterialsList.push(tempRow)
      this.rowClick(tempRow)
      console.log("添加")
    },
    //二三级物料，删除选中行
    deleteItemAll() {
      this.tableList.sTMaterialsList = this.tableList.sTMaterialsList.filter(v => !this.multipleSelection.includes(v.checkFrontId))
    },
    //二三级物料，删除单行
    @MultipleChoiceEnhancement()
    deleteItem(id) {
      this.tableList.sTMaterialsList = this.tableList.sTMaterialsList.filter(v => v.checkFrontId !== id)
    },
    //更新页面高度
    inspectionUpdate(height) {
      this.postThisPageHeight()
    },
    //点击四个列表TAB页
    @Log()
    handleClick(a) {
      console.log(a)
    },
    //查询样检单，四个列表和详情
    searchTableList() {
      // 数据查询中，请等待...
      this.startLoading(h_i18n('a1fa355af4de9de33a401ebb044bffb3'))
      this.tableListLoading = true
      return this.$http({
        method: "get",
        url: "/base/patternPlan/searchAPQPInfo?patternPlanId=" + this.beforeData.patternPlanId,
      }).then(res => {
        if (res.data.code === "200") {
          // console.log(res)
          this.mainData = res.data.data.apqpMain
          if(this.mainData.addressNo && this.mainData.addressNo != 'null'){
            this.placeOriginText = this.mainData.addressNo
          }else if(this.mainData.factoryAddress && this.mainData.factoryAddress != 'null'){
            this.placeOriginText = this.mainData.factoryAddress
          }else{
            this.placeOriginText = undefined
          }
          // if(this.mainData.factoryAddress && this.mainData.factoryAddress != 'null'){
          //   this.placeOriginText = this.mainData.factoryAddress
          // }else{
          //   this.placeOriginText = undefined
          // }
          this.cataId = this.mainData.id
          this.tableData = res.data.data.patternPlan
           // 自检拖期的回显
           if(this.tableData.selfDelayReason){
            this.selfDelayReason = this.tableData.selfDelayReason
            this.selfDelayReasonShow = true
          }
          if(this.tableData.selfDelayReasonRemark){
            this.selfDelayReasonRemark = this.tableData.selfDelayReasonRemark
            this.selfDelayReasonRemarkShow = true
          }
          this.tableList.sTMaterialsList = this.addCheckId(res.data.data["apqpMaterialList"], "sTMaterialsList").map(v => {
            return {
              ...v,
              // 自制；外协
              partStatusList: v.partStatus.replace("1", h_i18n('f5f45a306153e09e6b55aa8989e62e29')).replace("2", h_i18n('762f7d6568ff7dcbccb00c818e08c451')).split(",").filter(v => v)
            }
          })
          this.tableList.inspectionTesting = this.addCheckId(res.data.data["apqpInstestList"], "inspectionTesting").map(v => ({...v, judge: "P"}))
          this.tableList.technicalStandard = this.addCheckId(res.data.data["apqpTechstandardList"], "technicalStandard")
          this.tableList.hazardousSubstances = this.addCheckId(res.data.data["apqpRohsList"], "hazardousSubstances").map(v => v)
          this.tableListLoading = false
        } else {
          this.tableListLoading = false
        }
        this.closeLoading()
      }).catch(e => {
        this.closeLoading()
        this.tableListLoading = false
      })
    },
    //四个列表，每一行点击成输入框
    rowClick(row) {
      if (this.formType === 'upload') {
        this.tableList[row.checkFrontType].forEach(v => v.checkFront = false)
        row.checkFront = true
      }
    },
    //样检单列表每一行格式化，添加一个key
    addCheckId(list, type) {
      return list.map(v => {
        return {
          ...v,
          checkFrontId: this.md5(this.uuid2()),
          checkFront: false,
          checkFrontType: type
        }
      })
    },
    //四个保存，分别
    save(type) {
      switch (type) {
        case "sTMaterialsList":
          this.saveTS()
          break
        case "inspectionTesting":
          this.saveCT()
          break
        case "technicalStandard":
          this.saveIS()
          break
        case "hazardousSubstances":
          this.saveHS()
          break
      }
    },
    //二三级物料暂存
    saveTS(t = true) {
      // 借用此接口保存自检拖期参数
      // 需要拼上自检拖期的参数 
      let selfDelayReasonSaveData = null
      if(this.selfDelayReasonShow){
        if(this.selfDelayReason){
          selfDelayReasonSaveData = `&selfDelayReason=${this.selfDelayReason}`
        }
        if(this.selfDelayReasonRemarkShow && this.selfDelayReasonRemark){
          selfDelayReasonSaveData = `&selfDelayReason=${this.selfDelayReason}&selfDelayReasonRemark=${this.selfDelayReasonRemark}`
        }
      }
      if(this.placeOriginText && this.placeOriginText != 'null'){
        let address = this.placeOriginList.find(item=>item.addressNo === this.placeOriginText)?.factoryAdress || undefined
        // let url = "/base/patternPlan/saveApqpMaterial?cataId=" + this.cataId + "&factoryAddress=" + this.placeOriginText
        let url = ''
        if(address){
          url = "/base/patternPlan/saveApqpMaterial?cataId=" + this.cataId + "&factoryAddress=" + address +"&addressNo=" + this.placeOriginText
        }else{
          url = "/base/patternPlan/saveApqpMaterial?cataId=" + this.cataId +"&addressNo=" + this.placeOriginText
        }
        if(selfDelayReasonSaveData){
          // url = "/base/patternPlan/saveApqpMaterial?cataId=" + this.cataId + "&factoryAddress=" + this.placeOriginText + selfDelayReasonSaveData
          url = url + selfDelayReasonSaveData
        }
        return this.$http({
          method: "POST",
          // url: "/base/patternPlan/saveApqpMaterial?cataId=" + this.cataId + "&factoryAddress=" + this.placeOriginText,
          url: url,
          data: this.tableList.sTMaterialsList
        }).then(res => {
          if (res.data.data === "200" || res.data === true) {
            if (t) {
              // 保存成功
              this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
              this.searchTableList()
            }
          } else {
            if (t) {
              this.error({
                // 保存失败
                title: h_i18n('6de920b4e4e08b261cda928d9beefab4'),
                message: res.data.msg,
                // 确定
                confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
              })
            }
          }
        })
      }else{
        let url = "/base/patternPlan/saveApqpMaterial?cataId=" + this.cataId
        if(selfDelayReasonSaveData){
          url = "/base/patternPlan/saveApqpMaterial?cataId=" + this.cataId + selfDelayReasonSaveData
        }
        return this.$http({
          method: "POST",
          // url: "/base/patternPlan/saveApqpMaterial?cataId=" + this.cataId,
          url :url,
          data: this.tableList.sTMaterialsList
        }).then(res => {
          if (res.data.data === "200" || res.data === true) {
            if (t) {
              // 保存成功
              this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
              this.searchTableList()
            }
          } else {
            if (t) {
              this.error({
                // 保存失败
                title: h_i18n('6de920b4e4e08b261cda928d9beefab4'),
                message: res.data.msg,
                // 确定
                confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
              })
            }
          }
        })
      }
    },
    //检验测试暂存
    saveCT(t = true) {
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/saveApqpInstest?cataId=" + this.cataId,
        data: this.tableList.inspectionTesting
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          if (t) {
            // 保存成功
            this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
            this.searchTableList()
          }
        } else {
          if (t) {
            this.error({
              // 保存失败
              title: h_i18n('6de920b4e4e08b261cda928d9beefab4'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
            })
          }
        }
      })
    },
    //技术标准暂存
    saveIS(t = true) {
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/saveApqpTechstandard?cataId=" + this.cataId,
        data: this.tableList.technicalStandard
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          if (t) {
            // 保存成功
            this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
            this.searchTableList()
          }
        } else {
          if (t) {
            this.error({
              // 保存失败
              title: h_i18n('6de920b4e4e08b261cda928d9beefab4'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
            })
          }
        }
      })
    },
    //有害物质暂存
    saveHS(t = true) {
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/saveApqpRohs?cataId=" + this.cataId,
        data: this.tableList.hazardousSubstances
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          if (t) {
            // 保存成功
            this.success(h_i18n('3b108349b93f7c8c4e2346f8d48c092a'))
            this.searchTableList()
          }
        } else {
          if (t) {
            this.error({
              // 保存失败
              title: h_i18n('6de920b4e4e08b261cda928d9beefab4'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
            })
          }
        }
      })
    },
    //提交接口
    submit() {
      this.mainData.submitMan = this.$route.query.nickName
      // this.mainData.factoryAddress = this.placeOriginText
      this.mainData.addressNo = this.placeOriginText
      let address = this.placeOriginList.find(item=>item.addressNo === this.placeOriginText)?.factoryAdress || undefined
      this.mainData.factoryAddress = address
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/submitApqp",
        data: this.mainData
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          this.success({
            // 成功
            title: h_i18n('330363dfc524cff2488f2ebde0500896'),
            // 提交成功，请联系质量部长批准！！
            message: h_i18n('e9666b0e4405da3fe0aa1c46b2c42700'),
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            callback: () => {
              this.$router.back()
            }
          })
        } else {
          if (t) {
            this.error({
              // 提交失败
              title: h_i18n('f5d008dea7d2e953195a5588dea3c8e4'),
              message: res.data.msg,
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
            })
          }
        }
      })
    },
    //保存这四个页签
    async saveAll(flag) {
      // 暂存中...
      this.startLoading(h_i18n('79d5d7ae21d4e63b3358da84d522f9f5'))
      await this.saveTS(false)
      await this.saveCT(false)
      await this.saveIS(false)
      await this.saveHS(false)
      this.closeLoading()
      if(flag == 'back'){
        this.$router.back()
      }
    },
    //查询宣告表//patternPlan/searchRohsList
    selectDeclarationForm(supplyCode, rohsNo, mtlNo) {
      return this.$http({
        method: "get",
        url: "/base/patternPlan/searchRohsList",
        params: {
          supplyCode: supplyCode,
          rohsNo: rohsNo,
          mtlNo: mtlNo
        }
      }).then(res => {
        if (res.data.code === "200") {
          //effectStatus
          this.declarationFormList = res.data.data
          this.tableListLoading = false
        } else {
          this.tableListLoading = false
        }
      }).catch(e => {
        this.tableListLoading = false
      })
    },
    //提交所有信息
    async submitAll() {
      if (!this.beforeSubmit()) return
      if (!this.commitment) {
        this.info({
          // 提示
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          // 勾选我司承诺，并且提交
          message: h_i18n('04863f191ef8f2b2b6c60a787213a611'),
          // 确定
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          // 取消
          cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
          callback: async (action) => {
            if (action === "confirm") {
              this.commitment = true
              // 提交中...
              this.startLoading(h_i18n('abe2c5d2b9a91f822cb1c1ae6aefef08'))
              await this.saveTS(false)
              await this.saveCT(false)
              await this.saveIS(false)
              await this.saveHS(false)
              await this.submit()
              this.closeLoading()
            }
          }

        })
      } else {
        this.info({
          // 提示
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          // 确认提交吗？
          message: h_i18n('51cef0b50d5ef83883d4f2d37895cfff'),
          // 确定
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          // 取消
          cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
          callback: async (action) => {
            if (action === "confirm") {
              // 提交中...
              this.startLoading(h_i18n('abe2c5d2b9a91f822cb1c1ae6aefef08'))
              await this.saveTS(false)
              await this.saveCT(false)
              await this.saveIS(false)
              await this.saveHS(false)
              await this.submit()
              this.closeLoading()
            }
          }
        })
      }


    },
    //返回上一个页面
    goBack() {
      this.$router.back()
    },
    goBack2() {
      // 提示；请确认是否保存；确定；取消
      this.info({title:h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),message:h_i18n('70896fd0dc60a7d9a5ae22217130ba33'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
              callback: (action) => {
                if(action == 'confirm'){
                  this.saveAll('back')
                }else{
                  this.$router.back()
                }
              }
            })
    },
    //空校验
    checkEmpty(option, list, tab) {
      let a = option.map(v => v.name)
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < a.length; j++) {
          if (list[i].project === "出厂检验报告模板" && a[j] === "fileUuid") {

          } else if(list[i].isMust != 'Y'){

          } else {
            if (list[i][a[j]] === "" || !list[i][a[j]]) {
              console.log(list[i].isMust)
              // 在；，第；行中，'；'不允许为空！
              let str = `${h_i18n('241d47a3ee97f044c1f043b9ea81855b')}${tab}${h_i18n('bf8fa96b224c11bc9ec04def0304ca26')}${i + 1}${h_i18n('860622be568ef6ba9ce20b0da1baa698')}${option[j].text}${h_i18n('ee68958200b067557acc666757b4bcaa')}`
              this.warning(str)
              this.closeLoading()
              return false
            }
          }
        }
      }
      return true
    },
    //提交前验证所有要填写的信息
    beforeSubmit() {
      //二三级物料
      let a = [
        // I/II/III级
        {name: "series", text: h_i18n('911b9a994284ec787f4f24d6f25f3fe2')},
        // 零件号码
        {name: "partNumber", text: h_i18n('82428b489879f605914215b9876caa40')},
        // 零件名称
        {name: "partName", text: h_i18n('2bb79b0b11fb5f902349598676e2060e')},
        // 材料名称
        {name: "materialName", text: h_i18n('9ee1d06b4fb650c3e5fcc49929675caf')},
        // 规格参数
        {name: "specification", text: h_i18n('40c9875bd7978fac4de81ef58a454d28')},
        // 自制/外协零件
        {name: "partStatus", text: h_i18n('ed765ced3449b75aa70a4f5c10ad1334')},
        // 产品/材料供应商
        {name: "productSupplier", text: h_i18n('4dfbb9aa4ac63454b70dfd8bbe09def7')}
      ]
      //检验测试
      let b = [
        // 项目
        {name: "project", text: h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')},
        // 是否合格
        {name: "qualifiedStatus", text: h_i18n('3ba97bd751e79dff382d6ca65e4e3553')},
        // 检测时间
        {name: "testTime", text: h_i18n('44c4227175922c94497714edab9db531')},
        // 附件
        {name: "fileUuid", text: h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')},
        // 报告出具人
        {name: "submitMan", text: h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')}
      ]
      //技术标准
      let c = [
        // 项目
        {name: "project", text: h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')},
        // 是否合格
        {name: "qualifiedStatus", text: h_i18n('3ba97bd751e79dff382d6ca65e4e3553')},
        // 附件
        {name: "fileUuid", text: h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')},
        // 报告出具人
        {name: "submitMan", text: h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')}
      ]
      //有害物质
      let d = [
        // 项目
        {name: "project", text: h_i18n('31ecc0e65b4cd3e6b12577382bb56d6a')},
        // 宣告表编号
        {name: "rohsNo", text: h_i18n('c2cf8689fd0e8203797dbbd7f8475ff0')},
        // 是否合格
        {name: "judge", text: h_i18n('3ba97bd751e79dff382d6ca65e4e3553')},
        // 附件
        {name: "fileUuid", text: h_i18n('c9a6ee90f5d43732e3f6cf4dcaa8493c')},
        // 报告出具人
        {name: "submitMan", text: h_i18n('1470d600e4e06f5ea0100fc0bd2a363c')}
      ]
      if (this.placeOriginText === "" || !this.placeOriginText || this.placeOriginText == 'null') {
        // 请先选择产地
        this.warning(h_i18n('7a2da0b634d265ea106f5dc6b670cb54'))
        return false
      }
      // 校验自检拖期原因/说明
      if(this.selfDelayReasonShow && !this.selfDelayReason){
        // 请选择；自检拖期原因
        this.info(h_i18n('708c9d6d2ad108ab2c560530810deae9') + h_i18n('001768F5D0D251C2E86828DBCE241DA7'))
        return false
      }
      if(this.selfDelayReasonRemarkShow && (!this.selfDelayReasonRemark || /^\s+$/.test(this.selfDelayReasonRemark))){
        // 请输入；自检拖期其它原因说明
        this.info(h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7') + h_i18n('D4FF3F11C2E31A4448B6D158CDEB3690'))
        return false
      }
      // 二三级物料
      let aa = this.checkEmpty(a, this.tableList.sTMaterialsList, h_i18n('749ad86b2e655706785f3e38b9e7031c'))
      if (aa) {
        // 检验测试
        let bb = this.checkEmpty(b, this.tableList.inspectionTesting, h_i18n('23e0cee4c780d1d70657b0b32005fed2'))
        if (bb) {
          // 技术标准
          let cc = this.checkEmpty(c, this.tableList.technicalStandard, h_i18n('542c3a3ec2d96f011386760d7382940f'))
          if (cc) {
            // 有害物质
            let dd = this.checkEmpty(d, this.tableList.hazardousSubstances, h_i18n('f7ef9633c64559e80c654567ca5ddd96'))
            if (!dd) {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
      return true

    },
    //****************************************************自检批准****************************************************
    //批准
    approvePlan() {
      this.ratify = true
    },
    //批准提交前校核信息是否符合规范
    beforeApprove() {
      for (let i = 0; i < this.approveList.length; i++) {
        if (this.approveList[i].conclusion === "N" && this.approveList[i].reason === "") {
          // 不通过请填写备注说明！
          this.info(h_i18n('6e1f2b26e45ca8f4db473a426446d3e6'))
          return false
        }
      }
      // 校验自检拖期原因/说明 质量部长批准 不用判断
      // if(this.selfDelayReasonShow && !this.selfDelayReason){
      //   this.info(h_i18n('708c9d6d2ad108ab2c560530810deae9') + h_i18n('001768F5D0D251C2E86828DBCE241DA7'))
      //   return false
      // }
      // if(this.selfDelayReasonRemarkShow && !this.selfDelayReasonRemark){
      //   this.info(h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7') + h_i18n('D4FF3F11C2E31A4448B6D158CDEB3690'))
      //   return false
      // }
      return true
    },
    //批准提交/patternPlan/approveApqp
    approve() {
      // 提交中...
      this.startLoading(h_i18n('abe2c5d2b9a91f822cb1c1ae6aefef08'))
      let b = this.approveList.some(v => v.conclusion === "N")
      return this.$http({
        method: "POST",
        url: "/base/patternPlan/approveApqp",
        data: {
          id: this.mainData.id,
          apqpApproves: this.approveList,
          patternPlanId: this.tableData.patternPlanId,
          supplyAuditMan: this.$route.query.nickName,
          supplyAuditStatus: b ? "R" : "Y"
        }
      }).then(res => {
        if (res.data.data === "200" || res.data === true) {
          if (b) {
            this.success({
              // 驳回成功
              title: h_i18n('af3280a3e1a20232c243274c362dc40b'),
              // 请联系质量经理提交！！
              message: h_i18n('980d3f78d2864cfaac910e12f4f1442f'),
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: () => {
                this.$router.back()
              }
            })
          } else {
            this.success({
              // 提交成功
              title: h_i18n('23b62e9cbc868e024b80d2e3fad80ac7'),
              // 请联系海尔方审核！！
              message: h_i18n('4e19ab5c19c7a68a759cebf044abe3eb'),
              // 确定
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: () => {
                this.$router.back()
              }
            })
          }

        } else {
          this.error({
            // 提交失败
            title: h_i18n('f5d008dea7d2e953195a5588dea3c8e4'),
            message: res.data.msg,
            // 确定
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721')
          })
        }
        this.closeLoading()
      })
    },
    //提交所有信息
    approveAll() {
      if (!this.beforeApprove()) return
      if (!this.commitmentRatify) {
        this.info({
          // 提示
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          // 勾选我司承诺，并且提交
          message: h_i18n('04863f191ef8f2b2b6c60a787213a611'),
          // 确定
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          // 取消
          cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
          callback: async (action) => {
            if (action === "confirm") {
              this.commitmentRatify = true
              // 提交中...
              this.startLoading(h_i18n('abe2c5d2b9a91f822cb1c1ae6aefef08'))
              this.approve()
              this.closeLoading()
            }
          }

        })
      } else {
        this.info({
          // 提示
          title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
          // 确认提交吗？
          message: h_i18n('51cef0b50d5ef83883d4f2d37895cfff'),
          // 确定
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          // 取消
          cancelButtonText: h_i18n('625fb26b4b3340f7872b411f401e754c'),
          callback: async (action) => {
            if (action === "confirm") {
              // 提交中...
              this.startLoading(h_i18n('abe2c5d2b9a91f822cb1c1ae6aefef08'))
              this.approve()
              this.closeLoading()
            }
          }
        })
      }
    },
    //****************************************************自检打回****************************************************
  }
}
</script>

<style lang="scss">
.dialog_padding_style{
  .haier-dialog {
    .haier-dialog--body{
      padding: 16px !important;
    }
  }
}
</style>

<style scoped lang="scss">
.page {
  //.cell {
  //  div {
  //    text-align: left;
  //  }
  //}
  margin-top: 12px;
  .item-look {
    display: inline-block;
  }

  .table-top {
    padding: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 10px;
    box-sizing: border-box;

    .title-table {
      display: flex;
      height: 30px;
      font-size: 14px;
      justify-content: space-between;
      // font-weight: 600;
      color:#1D2129;
      .right {
        font-weight: 500;
      }
    }

    .item {
      margin-top: 10px;

      .item_table {
        width: 100%;

        tr {
          th {
            height: 40px;
            font-size: 16px;
            font-weight: 400;
          }

          td {
            height: 40px;
            font-size: 14px;
            font-weight: 400;
            text-align: center;
          }
        }
      }
    }
  }

  .table-tab {
    margin-top: 10px;
    background-color: #fff;
    padding: 4px 16px 16px;
    border-radius: 10px;

    .footer_check {
      display: flex;
      padding: 0 5px;
      font-size: 16px;
      color: #165DFF;
      font-weight: 900;
      justify-content: center;
      align-items: center;

      :deep(.el-checkbox) {
        display: flex;
        align-items: center;
      }

      :deep(.el-checkbox__input) {
        display: inline-flex;
        align-items: center;
      }

      :deep(.el-checkbox__label) {
        font-size: 16px;
      }
    }

    .demo-tabs {
      :deep(.el-tabs__content) {
        // padding: 10px;
        min-height: 320px;
      }

      .tab-item {
        width: 100%;
        height: 100%;

        .table-item-button {
          display: flex;

          .text {
            color: #F53F3F;
            font-size: 14px;
            display: flex;
            margin-left: 12px;
            align-items: center;
          }
        }

        .table-item-list {
          display: flex;
          height: 32px;
          margin-top: 10px;
          border: 1px solid #E5E6EB;
          border-radius: 8px;
          overflow: hidden;

          .item-one {
            width: 200px;
            flex: none;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            border-left: 1px solid #E5E6EB;
            padding: 0 10px;
          }


          .item-bg {
            background-color: #DDEDFE;
          }

          .item-one:first-child {
            border-left: 0;
          }

          .item-two {
            width: 0;
            border-left: 1px solid #E5E6EB;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            flex: 1;
            line-height: 32px;
            padding: 0 10px;
            font-size: 14px;
          }
        }
      }
    }

    .text_item {
      white-space: nowrap;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .text_item:hover {
      white-space: normal;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .text_item_delete {
      user-select: none;
      display: inline-block;
    }
  }

  .table-footer {
    padding: 10px;
    background-color: #fff;
    margin-top: 10px;
    border-radius: 10px;
  }

  .row-change {
    .current-row {
      td {
        padding: 7.5px 0;
      }
    }
  }
}

.footer_check_ratify {
  display: flex;
  padding: 0 5px;
  font-size: 16px;
  color: #165DFF;
  font-weight: 900;
  height: 50px;
  justify-content: center;
  align-items: center;
}

:deep(.el-drawer__header) {
  margin-bottom: 10px;
  padding: 0 10px;
  font-weight: 900;
  border-bottom: 1px dashed #E5E6EB;
}

.titleDrawer {
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
}
.import_style{
  :deep(ul){
    height: 100px;
    overflow-y: auto;
    li{
      display: table !important;
    }
  }
}
.detail-content{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  //margin-left: 15px;
  .detail-item{
    width: 25%;
    display: flex;
    .item-label{
      min-width: 45px;
      font-size: 14px;
      color: #4E5969;
    }
    .item-label1{
      width: 120px;
      font-size: 14px;
      color: #4E5969;
    }
    .item-content{
      font-size: 14px;
      color: #1D2129;
      .default_input_style{
        .el-textarea__inner{
          height: 100%;
          font-size: 14px;
        }
      }
    }
  }
}
// .myTr :first-child{
//   border-top-left-radius: 8px;
// }
// .myTr :last-child{
//   border-top-right-radius: 8px;
// }
// .myTr1 :first-child {
//   border-bottom-left-radius: 8px;
// }
// .myTr1 :last-child{
//   border-bottom-right-radius: 8px;
// }
.haier-form-page .el-table--border, .haier-form-page .haier-list-page .el-table--group{
  border: 1px solid #E5E6EB !important;
  border-bottom: none !important;
}
</style>